import { render, staticRenderFns } from "./FaqManagement.vue?vue&type=template&id=6431d00a&scoped=true&"
import script from "./FaqManagement.vue?vue&type=script&lang=js&"
export * from "./FaqManagement.vue?vue&type=script&lang=js&"
import style0 from "./FaqManagement.vue?vue&type=style&index=0&id=6431d00a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6431d00a",
  null
  
)

export default component.exports